/**
 * Shared animation constants.
 *
 * Two standard easing curves cover all animations in the app:
 *
 * EASE_EXPO_OUT — "expo-out": fast departure, smooth deceleration to rest.
 *   Use for Framer Motion content transitions (enter/exit, collapse, reorder).
 *
 * EASE_STANDARD — "standard": balanced ease for position/width interpolation.
 *   Use for CSS timeline data transitions (zone widths, tick positions).
 *   Equivalent to cubic-bezier(0.4, 0, 0.2, 1) — Material's standard curve.
 *
 * Three duration tiers:
 *   DURATION_FAST    — micro-interactions (hover, color, press feedback)
 *   DURATION_MEDIUM  — content enter/exit, collapse, fade
 *   DURATION_SLOW    — timeline data transitions, layout reorder
 */

/** Expo-out: fast start, smooth deceleration. Framer Motion content transitions. */
export const EASE_EXPO_OUT = [0.16, 1, 0.3, 1] as const;

/** Standard curve: balanced ease for CSS data transitions. cubic-bezier(0.4, 0, 0.2, 1). */
export const EASE_STANDARD = [0.4, 0, 0.2, 1] as const;

/** CSS string form of EASE_STANDARD for inline styles and Tailwind arbitrary values. */
export const EASE_STANDARD_CSS = 'cubic-bezier(0.4, 0, 0.2, 1)';

/** 150ms — micro-interactions (hover, color change, press feedback). */
export const DURATION_FAST = 0.15;

/** 200ms — content enter/exit, collapse, fade. */
export const DURATION_MEDIUM = 0.2;

/** 300ms — timeline data transitions, layout reorder. */
export const DURATION_SLOW = 0.3;
